import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page--limited" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "p-d-flex p-ai-center p-jc-between" }
const _hoisted_4 = { class: "p-fluid p-mt-3" }
const _hoisted_5 = { class: "p-d-flex p-jc-center p-mt-3" }
const _hoisted_6 = { class: "card flex1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", null, "Riepilogo ordini", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_ChipFilters = _resolveComponent("ChipFilters")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_OrderTable = _resolveComponent("OrderTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.$t(
        'billing_customer.title',
        { name: _ctx.customerName }
      ),
      showSave: false,
      showDelete: false,
      backRoute: _ctx.backRoute
    }, null, 8, ["title", "backRoute"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FloatLabel, {
          label: "Totale",
          class: "p-mr-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.total,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.total = $event)),
              currency: "EUR",
              mode: "currency",
              locale: "it-IT",
              disabled: _ctx.isLoading || _ctx.kpiLoading
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_ChipFilters, {
            from: _ctx.from,
            to: _ctx.to,
            zoneName: _ctx.zoneName
          }, null, 8, ["from", "to", "zoneName"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_FloatLabel, { label: "Note" }, {
          default: _withCtx(() => [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.note,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.note = $event)),
              placeholder: "Scrivi qui le note...",
              cols: "35"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          class: "p-button-lg p-mr-2",
          icon: "pi pi-check-circle",
          label: "Elabora",
          onClick: _ctx.onProcessClick,
          loading: _ctx.isLoading || _ctx.kpiLoading
        }, null, 8, ["onClick", "loading"]),
        _createVNode(_component_Button, {
          class: "p-button-lg",
          icon: "pi pi-download",
          label: "Esporta",
          onClick: _ctx.onExportClick,
          loading: _ctx.isExporting
        }, null, 8, ["onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_component_OrderTable, {
        isLoading: _ctx.isLoading,
        value: _ctx.orders,
        totalRecords: _ctx.totalRecords,
        onPage: _ctx.onPage
      }, {
        cols: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "est_price",
            header: "Prezzo",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { est_price }}) => [
              _createVNode(_component_CurrencyText, { modelValue: est_price }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "est_price_extra1_value",
            header: "Prezzo extra",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { est_price_extra1_value }}) => [
              _createVNode(_component_CurrencyText, { modelValue: est_price_extra1_value }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "tot_est_price",
            header: "Prezzo totale",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { tot_est_price }}) => [
              _createVNode(_component_CurrencyText, { modelValue: tot_est_price }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["isLoading", "value", "totalRecords", "onPage"])
    ])
  ]))
}